// 客服相关配置
// 电话
export const phone = {
  MX: '8000673469',
  BR: '03003130099',
  JP: '0120132355',
  CR: '50641063372',
  CO: '6015801398',
  DO: '(+) 18 29956 8643',
  CL: '(+56)227120527',
}

// 邮箱
export const email = {
  MX: 'soporte.food@mx.didiglobal.com',
  BR: '', // 巴西暂时没有邮箱配置
  JP: 'customer@didifood.co.jp',
  CR: '',
  CO: 'didifood.co@didiglocal.com',
  DO: '', // 多米尼加暂不配置邮箱
  CL: '', // 智利暂不配置邮箱
}

export default {
  phone,
  email,
}
